const variantOutline = () => {
  return {
    border: 0,
    bg: '#F6F7F8',
    _hover: {
      boxShadow: '0 0 0 1px #131415',
    },
    _readOnly: {
      boxShadow: 'none !important',
      userSelect: 'all',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    _invalid: {
      boxShadow: `0 0 0 2px #E94D5C`,
    },
    _focus: {
      boxShadow: '0 0 0 1px #131415',
      zIndex: 1,
    },
  };
};

const atsTextAreaVariant1 = () => {
  return {
    border: '2px solid',
    borderColor: 'border-color',
    bg: '#fff',
    p: '8px',
    _hover: {
      boxShadow: 'none',
    },
    _readOnly: {
      boxShadow: 'none !important',
      userSelect: 'all',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    _invalid: {
      boxShadow: 'none',
    },
    _focus: {
      outline: '4px solid',
      outlineColor: '#6220A30F',
      boxShadow: 'none',
      outlineOffset: '0',
      borderColor: 'ats-primary',
    },
    _placeholder: {
      color: ' #7E7E7E',
    },
  };
};

export const Textarea = {
  baseStyle: {},
  sizes: {
    md: {
      fontSize: '14px',
    },
  },
  variants: {
    outline: variantOutline,
    'ats-textarea-variant-1': atsTextAreaVariant1,
  },
  defaultProps: {
    variant: 'outline',
    size: 'md',
  },
};
